import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/jobRequests'
import Component from 'components/JobRequests/FormView/Decline'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { decline: actions.decline })(Component)
